module.exports = __webpack_public_path__ + "img/placeholder.62ad2c94.svg";